module.exports = __webpack_public_path__ + "img/abyss-ss.4352bc4c.png";